import { Close as DeleteIcon } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { Nullable } from "../../../../../common/types/nullable";
import { AccumDateRow } from "../../../../employment/employmentApi";
import { StyledTableCell } from "../styles";
import { SelectedAccumulation } from "../types";

type Props = {
  rowData: AccumDateRow;
  openConfimationDialog: (deltaId: string) => void;
  dataIncludesDelta: boolean;
  selectedAccumulation: Nullable<SelectedAccumulation>;
  canEdit: boolean;
};

const AccumulationsTableAdditionalTableCells = ({
  rowData,
  openConfimationDialog,
  dataIncludesDelta,
  selectedAccumulation,
  canEdit,
}: Props) => {
  return (
    <>
      {rowData.deltaId && (
        <StyledTableCell sx={{ padding: 0, paddingRight: "8px" }} align="right">
          {canEdit && (
            <IconButton
              sx={{ padding: "6px" }}
              onClick={() => openConfimationDialog(rowData.deltaId as string)}
            >
              <DeleteIcon sx={{ width: "20px", height: "20px" }} />
            </IconButton>
          )}
        </StyledTableCell>
      )}
      {(dataIncludesDelta || selectedAccumulation?.isInternal) &&
        !rowData.deltaId && <StyledTableCell />}
    </>
  );
};

export default AccumulationsTableAdditionalTableCells;
